"use client";

import { c as _c } from "react/compiler-runtime";
import type { SeasonMintRow } from "@/components/meme-calendar/meme-calendar.helpers";
import { getUpcomingMintsAcrossSeasons, isMintingToday } from "@/components/meme-calendar/meme-calendar.helpers";
import ShowMoreButton from "@/components/show-more-button/ShowMoreButton";
import type { NFTSubscription } from "@/generated/models/NFTSubscription";
import type { SubscriptionDetails } from "@/generated/models/SubscriptionDetails";
import { useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import MemeSubscriptionRow from "./MemeSubscriptionRow";
import styles from "./UserPageSubscriptions.module.scss";
export default function UserPageSubscriptionsUpcoming(props) {
  const $ = _c(32);
  const [expanded, setExpanded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [subscriptions, setSubscriptions] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== expanded || $[2] !== props.memes_subscriptions) {
    t1 = () => {
      const subs = props.memes_subscriptions;
      if (expanded) {
        setSubscriptions(subs);
      } else {
        setSubscriptions(subs.slice(0, 3));
      }
    };
    t2 = [props.memes_subscriptions, expanded];
    $[1] = expanded;
    $[2] = props.memes_subscriptions;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const [now] = useState(_temp);
  let t3;
  if ($[5] !== now || $[6] !== props.memes_subscriptions.length) {
    t3 = getUpcomingMintsAcrossSeasons(props.memes_subscriptions.length, now);
    $[5] = now;
    $[6] = props.memes_subscriptions.length;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const rows = t3;
  let t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Row><Col><h5 className="mb-0 tw-font-semibold">Upcoming Drops</h5></Col></Row>;
    t5 = <hr className="tw-border-white tw-opacity-100 tw-border-2 tw-mt-1 tw-mb-0" />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[10] !== props.details?.subscription_eligibility_count || $[11] !== props.profileKey || $[12] !== props.readonly || $[13] !== props.refresh || $[14] !== rows || $[15] !== subscriptions) {
    let t7;
    if ($[17] !== props.details?.subscription_eligibility_count || $[18] !== props.profileKey || $[19] !== props.readonly || $[20] !== props.refresh || $[21] !== rows || $[22] !== subscriptions.length) {
      t7 = (subscription, index) => <div key={subscription.token_id} className={`${styles.nftSubscriptionsListItem} ${index % 2 === 0 ? styles.odd : styles.even} ${index === subscriptions.length - 1 ? styles.last : ""}`}><MemeSubscriptionRow profileKey={props.profileKey} title="The Memes" subscription={subscription} eligibilityCount={props.details?.subscription_eligibility_count ?? 1} readonly={props.readonly} refresh={props.refresh} minting_today={index === 0 && isMintingToday()} first={index === 0} date={rows[index] ?? null} /></div>;
      $[17] = props.details?.subscription_eligibility_count;
      $[18] = props.profileKey;
      $[19] = props.readonly;
      $[20] = props.refresh;
      $[21] = rows;
      $[22] = subscriptions.length;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    t6 = subscriptions.map(t7);
    $[10] = props.details?.subscription_eligibility_count;
    $[11] = props.profileKey;
    $[12] = props.readonly;
    $[13] = props.refresh;
    $[14] = rows;
    $[15] = subscriptions;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[24] !== t6) {
    t7 = <div>{t6}</div>;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== expanded || $[27] !== props.memes_subscriptions.length) {
    t8 = props.memes_subscriptions.length > 3 && <div className="mt-2 text-center"><ShowMoreButton expanded={expanded} setExpanded={setExpanded} /></div>;
    $[26] = expanded;
    $[27] = props.memes_subscriptions.length;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t7 || $[30] !== t8) {
    t9 = <Container className="no-padding">{t4}{t5}<Row><Col>{t7}{t8}</Col></Row></Container>;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}
function _temp() {
  const d = new Date();
  d.setUTCHours(0, 0, 0, 0);
  return d;
}